module.exports = __webpack_public_path__ + "media/newstyle/images/epub3-type-804f5350775a32aac0c5dd9786448b1a.png";